<template>
  <!-- 头部 -->
  <header-menu v-show="route.name === 'home'" />
  <div class="main" v-show="route.name === 'home'">
    <!-- 轮播图 -->
    <van-swipe :show-indicators="false" :autoplay="3000" class="swiper">
      <van-swipe-item v-for="item in data.SwiperList.item" :key="item.id"
        ><img :src="item.source_url" alt="" @click="data.goSwiper(item)"
      /></van-swipe-item>
    </van-swipe>
    <!-- tabs -->
    <van-tabs
      v-model:active="data.active"
      line-width="10vw"
      line-height="4px"
      color="#8368FCFF"
      background="#111525"
      title-inactive-color="#F7F5FF60"
      title-active-color="#ffffff"
      :swipeable="true"
      @click-tab="data.tabsChange"
    >
      <van-tab
        title-class="tabsTitleClass"
        :name="item.id"
        v-for="item in data.tabs"
        :key="item.id"
      >
        <template #title>
          <div :class="item.id === 'flower' ? 'icon' : ''">
            {{ item.name }}
          </div>
        </template>
      </van-tab>
    </van-tabs>
    <!-- 内容 -->
    <div
      class="cardList"
      :class="store.isSafari ? 'isSafariClass' : ''"
      ref="card"
      v-if="data.active !== 'flower'"
    >
      <div class="card" v-for="(card, index) in data.list" :key="index">
        <van-skeleton v-if="data.loading">
          <template #template>
            <div :style="{ flex: 1 }">
              <van-skeleton-paragraph row-width="60%" />
              <van-skeleton-paragraph />
              <van-skeleton-paragraph class="skeletonBtn" />
              <van-skeleton-paragraph class="skeletonBadge" />
            </div>
          </template>
        </van-skeleton>
        <div v-else>
          <div class="img">
            <img :src="card.icon" alt="" />
          </div>
          <div class="title">
            {{ card.name }}
          </div>
          <div class="tip">
            {{ card.desc }}
          </div>
          <div class="btn" @click="data.use(card)">使用</div>
          <div
            class="badge"
            v-if="card.label.length !== 0"
            :style="'background:' + card.label[0].color"
          >
            {{ card.label[0].name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 瀑布流 -->
    <div class="container" v-else>
      <van-list
        v-model:loading="data.loadingContainer"
        :finished="data.finished"
        finished-text="没有更多了"
        @load="data.onLoad"
      >
        <div class="masonry" ref="masonryRef">
          <div
            id="column1"
            class="column"
            ref="column1"
            :style="
              data.column1.length === 0 ||
              data.column2.length === 0 ||
              data.column1.length !== 0
                ? 'width:50%'
                : ''
            "
          >
            <div
              class="masonry-item"
              @click="data.quitImg(item)"
              v-for="item in data.column1"
              :key="item.img_url"
            >
              <div class="masonry-item-img">
                <img
                  :src="
                    item.img_url +
                    '?x-oss-process=image/resize,w_500/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
                  "
                  alt=""
                />
              </div>
              <div class="content">{{ item.name }}</div>
              <div class="bottom">
                <div class="btn" @click.stop="data.quit(item)">
                  一键创作同款
                </div>
                <div class="giveLike" @click.stop="data.setLikeGallery(item)">
                  <img
                    v-if="item.is_like === 0"
                    src="@/assets/quietMind.png"
                    alt=""
                  />
                  <img v-else src="@/assets/redMind.png" alt="" />
                  {{ data.getlickText(item.likes) }}
                </div>
              </div>
            </div>
          </div>
          <div
            id="column2"
            class="column"
            ref="column2"
            :style="
              data.column1.length === 0 ||
              data.column2.length === 0 ||
              data.column2.length !== 0
                ? 'width:50%'
                : ''
            "
          >
            <div
              class="masonry-item"
              @click="data.quitImg(item)"
              v-for="item in data.column2"
              :key="item.img_url"
            >
              <div class="masonry-item-img">
                <img
                  :src="
                    item.img_url +
                    '?x-oss-process=image/resize,w_500/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
                  "
                  alt=""
                />
              </div>
              <div class="content">{{ item.name }}</div>
              <div class="bottom">
                <div class="btn" @click.stop="data.quit(item)">
                  一键创作同款
                </div>
                <div class="giveLike" @click.stop="data.setLikeGallery(item)">
                  <img
                    v-if="item.is_like === 0"
                    src="@/assets/quietMind.png"
                    alt=""
                  />
                  <img v-else src="@/assets/redMind.png" alt="" />
                  {{ data.getlickText(item.likes) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
  <!-- 绘画弹出框 -->
  <van-popup
    class="drawing"
    v-model:show="data.drawing"
    round
    position="bottom"
    teleport=".main"
    :safe-area-inset-bottom="true"
    @closed="data.drawingPopupClosed"
  >
    <div class="close" @click="data.drawingPopupClose">
      <img src="@/assets/homeClose.png" alt="" />
      <div class="watermark">花集AI精灵</div>
    </div>
    <div class="popupHeader">作品详情</div>
    <div class="popupImg">
      <img
        :src="
          data.quitImgData.img_url +
          '?x-oss-process=image/resize,w_500/watermark,type_d3F5LXplbmhlaQ,size_20,text_6Iqx6ZuGQUnnsr7ngbUK,color_8368FC,t_100,g_se,x_10,y_10'
        "
        alt=""
      />
    </div>
    <div class="popupTitle">
      标题：<span class="title">{{ data.quitImgData.name }}</span>
    </div>
    <div class="popupTitle">
      作者：<span class="title">{{ data.quitImgData.nickname }}</span>
    </div>
    <div class="popupBtn">
      一键创作同款（{{ data.quitImgData.petal_price }}花瓣/次）
    </div>
  </van-popup>
  <!-- 新人注册 -->
  <van-popup
    class="register"
    @closed="data.closed"
    v-model:show="data.register"
    position="bottom"
    teleport=".main"
  >
    <div class="card">
      <img src="@/assets/homeClose.png" @click="data.undateNameBtn" />
      <div class="title">新用户首次登录获赠30花瓣</div>
      <div class="tip">欢迎你</div>
      <van-field v-model="data.registerName" placeholder="请输入用户名" />
      <div class="btnList">
        <div @click="data.delNameList">不喜欢，换一个</div>
        <div class="btn" @click="data.undateNameBtn">确认</div>
      </div>
    </div>
  </van-popup>
  <router-view />
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onUpdated,
  onMounted,
  watchEffect,
  computed,
  nextTick,
  onActivated,
  onDeactivated,
  onBeforeUnmount,
  watch,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import Swiper from "swiper";
import headerMenu from "@/components/headerMenu.vue";
import {
  getName,
  undateName,
  homeInfo,
  category,
  flower,
  getsign,
  lickgalley,
} from "@/api/home";
import { showSuccessToast, showFailToast } from "vant";
import cross from "@/assets/cross.png";
import { again } from "@/api/img";
import { appDeteil } from "@/api/text";
import { userInfo } from "@/api/login";
import { getToken } from "@/ulits/auth";
import isotope from "isotope-layout";
import packery from "packery";
/**
 * 仓库
 */
const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
const masonryRef = ref(null);
const column1 = ref(null);
const column2 = ref(null);
data.NameFLage = true;
data.height = 0;
data.column1 = [];
data.column2 = [];
data.drawing = false;
data.register = false;
data.closedFlag = true;
data.nameList = [];
data.onLoadFlage = false;
data.likeGalleryFlag = true;
data.registerName = "";
data.active = "flower";
data.SwiperList = [];
data.col1 = [];
data.col2 = [];
data.appInfo = {};
data.colList = [];
data.loading = false;
data.loadingContainer = false;
data.finished = false;
data.list = Array(6).fill({});
data.page = 1;
// 1-文案写作|2-创意绘图|3-花店创业|4-电商运营',
data.tabs = [
  {
    id: "flower",
    name: "作品画廊",
  },
  {
    id: "all",
    name: "全部应用",
  },
];
// 选项卡节点
const card = ref(null);
// 首页轮播图
data.initSwiper = () => {
  new Swiper("#home", {
    simulateTouch: true, // 允许鼠标点击和拖动
    shortSwipes: true, // 设置短距离滑动有效
    longSwipes: true,
  });
};

// 首页tabs选项卡标签
data.getCategory = () => {
  category().then((res) => {
    data.tabs.push(...res.data);
    nextTick(() => {
      data.active = store.active;
      if (data.active === "flower") {
        if (!data.onLoadFlage) {
          data.getFlower();
        }
      } else {
        data.getHomeInfo();
      }
    });
  });
};

// 获取首页内容
data.getHomeInfo = () => {
  data.loading = true;
  homeInfo({ type: data.active })
    .then((res) => {
      if (res.code === 200) {
        data.SwiperList = res.data.ad[0];
        if (data.active === "all") {
          data.list = res.data.category;
          //   res.data.category.filter(i=>{
          //    data.list.push(...i.apps)
          //   })
        } else {
          data.list = res.data.category[0].apps;
        }
        nextTick(() => {
          card.value.scrollTop = store.scrollTop;
          store.setScrollTop(0);
        });
        data.loading = false;
      }
    })
    .catch(() => {
      data.loading = false;
    });
};

// 作品画廊数据
data.getFlower = () => {
  const info = localStorage.getItem("userInfo");
  flower({
    page: data.page,
    limit: 10,
    user_id: info ? JSON.parse(info).id : "",
  }).then((res) => {
    if (res.code === 200) {
      data.colList.push(...res.data.data);
      const list1 = res.data.data.filter((item, index) => {
        return index % 2 === 0;
      });
      const list2 = res.data.data.filter((item, index) => {
        return index % 2 !== 0;
      });
      data.column1.push(...list1);
      data.column2.push(...list2);
      if (res.data.data.length < 10) {
        data.finished = true;
      } else {
        data.page = data.page + 1;
        data.finished = false;
      }
      data.loadingContainer = false;
    }
  });
};

// 画廊制作同款按钮
data.quitImg = (e) => {
  localStorage.setItem("imgInfo", JSON.stringify(e));
  router.push({ name: "imgInfo", query: { type: "index" } });
};

// 选项卡点击事件
data.tabsChange = (e) => {
  store.setActive(e.name);
  data.loading = true;
  if (e.name === "flower") {
  } else {
    if (card.value) {
      card.value.scrollTop = 0;
    }
    data.getHomeInfo();
  }
};

// app 使用按钮
data.use = (e) => {
  store.setScrollTop(card.value.scrollTop);
  appDeteil({ app_id: e.pivot ? e.pivot.app_id : e.id }).then((res) => {
    store.setAppInfo(res.data);
    localStorage.setItem(
      "category_id",
      e.pivot ? e.pivot.category_id : e.category[0].id
    );
    localStorage.setItem("appInfo", JSON.stringify(res.data));
    store.copywritingTrue();
    if (res.data.creation_type === 3) {
      store.setGenerate(true);
    }
    router.push({ name: "appliance" });
  });
};

//判断是否新用户
data.quit = (e) => {
  let userInfo = localStorage.getItem("userInfo");
  if (!userInfo) {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
    router.push({
      name: "login",
    });
  }
  again({
    app_id: e.app_id,
    chat_id: e.same_model_id,
    is_open: JSON.parse(userInfo).is_info_public,
  }).then((res) => {
    if (res.code === 200) {
      appDeteil({ app_id: e.app_id }).then((res) => {
        store.setCreateFlag(false);
        store.setGenerate(false);
        store.setAppInfo(res.data);
        store.copywritingFalse();
        localStorage.setItem("appInfo", JSON.stringify(res.data));
        router.push({ name: "appliance" });
      });
    }
  });
};

// 新用户弹窗获取/更换名字
data.getNameList = () => {
  if (data.NameFLage) {
    data.NameFLage = false;
    getName().then((res) => {
      if (res.code === 200) {
        data.NameFLage = true;
        data.registerName = res.data.name[0];
        data.nameList = res.data.name;
      }
    });
  }
};

data.delNameList = () => {
  data.nameList.shift();
  if (data.nameList.length !== 0) {
    data.registerName = data.nameList[0];
  } else {
    data.getNameList();
  }
};

// 弹窗名字确认按钮
data.undateNameBtn = () => {
  data.closedFlag = false;
  const info = localStorage.getItem("userInfo");
  let userId;
  if (info) {
    userId = JSON.parse(info).id;
  }
  if (data.registerName) {
    undateName({ nickName: data.registerName }).then((res) => {
      if (res.code === 200) {
        data.register = false;
        localStorage.removeItem("userInfo");
        userInfo({ user_id: userId }).then((user) => {
          if (user.code === 200) {
            store.setUserInfo(user.data);
            localStorage.setItem("userInfo", JSON.stringify(user.data));
          }
        });
      } else {
        data.registerName = "";
        showFailToast({
          message: res.message,
          icon: cross,
        });
      }
    });
  } else {
    showFailToast({
      message: "用户名不可以为空",
      icon: cross,
    });
  }
};

data.getSgin = () => {
  getsign({ url: location.href.split("?")[0] }).then((res) => {
    if (res && res.code === 200) {
      jWeixin.config({
        debug: false, // 调试时可开启
        appId: "wxf30ed3615020811d", // <!-- replace -->
        timestamp: res.data.timestamp, // 必填，填任意数字即可
        nonceStr: res.data.noncestr, // 必填，填任意非空字符串即可
        signature: res.data.sign, // 必填，填任意非空字符串即可
        jsApiList: [
          "startRecord",
          "chooseWXPay",
          "stopRecord",
          "translateVoice",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
          "updateAppMessageShareData",
        ], // 必填，随意一个接口即可
      });
    }
  });
  wx.ready(function () {
    wx.onMenuShareAppMessage({
      title: "花集AI精灵",
      desc: "智慧伴你 随心所欲",
      link: "https://www.aibene.cn",
      imgUrl:
        "https://aibene-resource.huaji.com/png/20231010/202310101603452738.png",
    });
  });
};
// 下拉刷新
data.onLoad = () => {
  data.onLoadFlage = true;
  data.getFlower();
};

data.goSwiper = (e) => {
  if (e.is_jump === 1) {
    window.open(e.target_url);
  }
};

data.getlickText = (e) => {
  let text = "";
  if (e === 0) {
    text = "赞";
  } else if (e < 10000) {
    text = e;
  } else {
    text = data.toFixedWithoutRounding(e / 10000, 1) + "万";
  }
  return text;
};

data.toFixedWithoutRounding = (n, fixed) => {
  let multiplier = Math.pow(10, fixed);
  n = Math.floor(n * multiplier) / multiplier;
  return n.toFixed(fixed);
};

data.setLikeGallery = (e) => {
  let userInfo = localStorage.getItem("userInfo");
  if (userInfo && getToken()) {
    if (data.likeGalleryFlag) {
      data.likeGalleryFlag = false;
      lickgalley({ id: e.id })
        .then((res) => {
          if (res.code === 200) {
            if (e.is_like === 0) {
              e.is_like = 1;
              e.likes = e.likes + 1;
            } else {
              e.is_like = 0;
              e.likes = e.likes - 1;
            }
          }
        })
        .finally(() => {
          data.likeGalleryFlag = true;
        });
    }
  } else {
    showFailToast({
      message: "请先登录",
      icon: cross,
    });
  }
};

// 监听首页弹框
watch(
  () => store.register,
  (newCount, oldCount) => {
    if (newCount === true) {
      data.getNameList();
      data.register = true;
      store.setRegister(false);
    }
    // 当 count 发生变化时，以下代码将被执行
    // 在这里，你可以添加你自己的逻辑...
  }
);

watch(
  () => store.undateFlag,
  () => {
    data.colLis = [];
    data.column1 = [];
    data.column2 = [];
    data.finished = false;
    data.page = 1;
    data.loadingContainer = false;
    data.getFlower();
  }
);

watch(
  () => store.imgDate.is_like,
  () => {
    data.column1.filter((item) => {
      if (item.id === store.imgDate.id) {
        item.is_like = store.imgDate.is_like;
        if (item.is_like === 1) {
          item.likes = item.likes + 1;
        } else {
          item.likes = item.likes - 1;
        }
      }
    });
    data.column2.map((item) => {
      if (item.id === store.imgDate.id) {
        item.is_like = store.imgDate.is_like;
        if (item.is_like === 1) {
          item.likes = item.likes + 1;
        } else {
          item.likes = item.likes - 1;
        }
      }
    });
  }
);

onBeforeMount(() => {
  console.log(1);
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});

onBeforeUnmount(() => {
  console.log(1);
});

onActivated(() => {
  console.log("组件被激活");
});

onDeactivated(() => {
  console.log("组件被停用");
});

onMounted(() => {
  let u = navigator.userAgent;
  // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (store.WxFlage) {
    data.getSgin();
  }
  data.getHomeInfo();
  data.getCategory();
  // data.getUserinfo()
  // data.initSwiper()
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.main {
  padding: 24px;
  background: #111525;
  .swiper {
    border-radius: 20px;
    img {
      width: 100%;
      height: 240px;
      border-radius: 20px;
    }
  }
  ::v-deep().van-tabs__wrap {
    height: 8vw;
  }
  ::v-deep().tabsTitleClass {
    font-size: 30px;
    min-width: 150px;
    .icon {
      margin-right: 20px;
    }
    .icon::before {
      content: "";
      display: block;
      height: 22px;
      width: 18px;
      position: absolute;
      background: url("~@/assets/huao.png") no-repeat;
      background-size: 100%;
      left: 140px;
      bottom: 18px;
    }
  }
  .isSafariClass {
    height: calc(100vh - 645px) !important;
  }
  .cardList {
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    margin-top: 32px;
    height: calc(100vh - 490px);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 24px;
    grid-template-rows: 346px;
    .card {
      height: 346px;
      border-radius: 24px;
      background-color: #323647;
      padding-left: 30px;
      position: relative;
      .img {
        position: absolute;
        width: 128px;
        height: 128px;
        top: 30px;
        img {
          width: 128px;
          height: 128px;
        }
      }
      .title {
        padding-top: 118px;
        color: #ffffff;
        font-size: 30px;
        font-weight: 300;
        position: relative;
      }
      .tip {
        margin-top: 9px;
        font-size: 22px;
        color: #f7f5ff;
        font-weight: 300;
      }
      .btn {
        width: 188px;
        height: 78px;
        border-radius: 39px;
        font-size: 32px;
        border: 1px solid #ffffff;
        color: #fdfdff;
        font-weight: 500;
        text-align: center;
        line-height: 78px;
        position: absolute;
        bottom: 20px;
      }
      .badge {
        width: 148px;
        height: 48px;
        background: #3385ff;
        color: #f7f5ff;
        font-size: 26px;
        border-radius: 0px 24px 0px 16px;
        line-height: 48px;
        text-align: center;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  ::v-deep().van-skeleton {
    margin-top: 108px;
    .van-skeleton-paragraph {
      margin-top: 20px;
      height: 30px;
    }
    .skeletonBtn {
      position: absolute;
      bottom: 32px;
      left: 32px;
      width: 188px !important;
      height: 78px;
      border-radius: 39px;
    }
    .skeletonBadge {
      margin-top: 0;
      width: 148px !important;
      height: 48px;
      border-radius: 0px 24px 0px 16px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .container {
    margin-top: 32px;
    overflow: hidden;
    position: relative;
    overflow-y: auto;
    height: calc(100vh - 500px);
  }
  .item {
    margin-top: 48px;
    border-radius: 12px;
    .content {
      margin-top: 12px;
      color: #f7f5ff;
      font-size: 26px;
      font-weight: 300;
    }
    .btn {
      margin-top: 12px;
      width: 216px;
      height: 58px;
      background: #8368fc;
      border-radius: 10px;
      color: #ffffff;
      font-size: 28px;
      font-weight: 400;
      text-align: center;
      line-height: 58px;
    }
  }
  .cardList::-webkit-scrollbar {
    width: 0 !important;
  }
  .container::-webkit-scrollbar {
    width: 0 !important;
  }
}

::v-deep().drawing {
  border-radius: 48px 48px 0 0 !important;
  font-weight: 500;
  color: #222222;
  text-align: center;
  font-size: 34px;
  .close {
    position: absolute;
    right: 32px;
    top: 40px;
    cursor: pointer;
    img {
      width: 48px;
      height: 48px;
    }
  }
  .popupHeader {
    margin-top: 40px;
  }
  .popupImg {
    margin-top: 32px;
    img {
      height: 504px;
      width: 590px;
      border-radius: 20px;
    }
  }
  .popupTitle {
    margin-top: 24px;
    text-align: right;
    padding-right: 65px;
    font-weight: 500;
    color: #444444;
    font-size: 30px;
    .title {
      font-weight: 400;
      color: #444444;
    }
  }
  .popupBtn {
    margin: 0 auto;
    width: 600px;
    height: 88px;
    background: #8368fc;
    border-radius: 44px;
    font-weight: 400;
    color: #ffffff;
    font-size: 32px;
    line-height: 88px;
    margin-top: 68px;
  }
}
::v-deep().register {
  background: transparent;
  .card {
    margin: 0 24px 85px 24px;
    background: #ffffff;
    border-radius: 48px 43px 43px 43px;
    position: relative;
    .title {
      padding-top: 40px;
      text-align: center;
      font-weight: 400;
      color: #222222;
    }
    img {
      width: 48px;
      height: 48px;
      position: absolute;
      top: 40px;
      right: 30px;
      cursor: pointer;
    }
    .tip {
      margin-top: 48px;
      text-align: center;
      font-weight: 500;
      color: #8368fc;
      font-size: 32px;
    }
    .van-field {
      width: 558px;
      margin: auto;
      margin-top: 32px;
      font-size: 30px;
      padding: 23px 39px;
      background: #eeeeee;
      border-radius: 24px;
      .van-field__control {
        color: black !important;
      }
    }
    .btnList {
      display: flex;
      padding: 0 72px;
      color: #555555;
      font-size: 30px;
      align-items: center;
      justify-content: space-between;
      margin-top: 44px;
      padding-bottom: 68px;
      .btn {
        width: 264px;
        height: 88px;
        background: #8368fc;
        border-radius: 24px;
        font-weight: 400;
        text-align: center;
        line-height: 88px;
        color: #ffffff;
      }
    }
  }
}
::v-deep().van-tabs__nav {
  overflow-y: auto;
}
.masonry {
  margin-top: 10px;
  min-height: calc(100vh - 500px);
  //   column-count: 2;
  //   column-gap: 1em;
  display: flex;
  //   .column{
  //    width: 50%;
  //    position: absolute;
  //   }
  #column1 {
    .masonry-item {
      padding-right: 15px;
    }
  }
  #column2 {
    .masonry-item {
      padding-left: 15px;
    }
  }
}
.masonry-item-img {
  position: relative;
  .watermark {
    position: absolute;
    bottom: 20px;
    right: 10px;
    color: #8368fc50;
    font-size: 24px;
  }
}
.masonry-item {
  position: relative;
  //   break-inside: avoid;
  margin-bottom: 1em;
  //   width: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
  .content {
    margin-top: 12px;
    color: #f7f5ff;
    font-size: 26px;
    font-weight: 300;
  }
  .bottom {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn {
      padding: 0 21px;
      height: 64px;
      background: #8368fc;
      border-radius: 10px;
      color: #ffffff;
      font-size: 28px;
      font-weight: 400;
      text-align: center;
      line-height: 64px;
    }
    .giveLike {
      display: flex;
      align-items: center;
      font-size: 28px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #f7f5ff;
      img {
        margin-right: 4px;
        width: 44px;
        height: 44px;
      }
    }
  }
}
</style>
<style>
:root {
  --van-list-text-font-size: 28px !important;
}
</style>
